<template>
  <div class="pagination-container" :class="alignment">
    <div class="page-icon" v-for="index in totalPages" :key="index">
      <i v-if="index - 1 === currentPage" class="fas fa-circle"></i>
      <i v-else class="far fa-circle clickable" @click="iconClick(index-1)"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationBar",
  props: {
    alignment: String,
    totalPages: Number,
    currentPage: Number,
  },
  emits:['pageClick'],
  data: () => {
    return {

    };
  },
  methods:{
      iconClick(i){
          this.$emit('pageClick',i);
      }
  },
  computed:{
      
  }
};
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--pagination-icon-color, #fff);
  font-size: var(--pagination-icon-size, 14px);
}
.pagination-container i {
  margin: var(--pagination-icon-margin, 0px 3px);
}
.pagination-container.left {
  justify-content: flex-start;
}
.pagination-container.right {
  justify-content: flex-end;
}
.clickable{
    user-select: none;
    cursor: pointer;
}
</style>
